import type {
  CaseDashboardModel,
  CaseDashboardState,
} from '@/components/case-dashboard/dashboard-view'

/** Keep the last successful read visible when a background refresh fails. */
export function dashboardState(query: {
  data: CaseDashboardModel | undefined
  isError: boolean
}): CaseDashboardState {
  if (query.data) return { status: 'ready', dashboard: query.data }
  return { status: query.isError ? 'failed' : 'loading' }
}
